var map = {
	"./CasinoLive.js": "d875",
	"./CockAndCasinoLive.js": "b02f",
	"./Cockfight.js": "9aca",
	"./Lottery.js": "f142",
	"./Lottery3d.js": "ba1d",
	"./LotteryVN1.js": "e70c",
	"./LotteryVN2.js": "136b",
	"./Lotto.js": "d6e8",
	"./MachineGames.js": "3d71",
	"./allstatement.js": "f40e",
	"./auth.js": "446a",
	"./casino.js": "826a",
	"./deposit.js": "f324",
	"./depositrequest.js": "f562",
	"./index.js": "b2c6",
	"./keno.js": "8001",
	"./machine_baccarat.js": "45fe",
	"./machine_do_den.js": "e9a3",
	"./machine_klaklouk.js": "ddb7",
	"./machine_sic_bo.js": "0b1e",
	"./machine_tai_xiu.js": "b0df",
	"./machine_tiger_dragon.js": "8133",
	"./moneyrequest.js": "fd71",
	"./myInfo.js": "c55a",
	"./register.js": "9eae",
	"./result.js": "9d568",
	"./sport.js": "5441",
	"./withdraw.js": "b8cc",
	"./withdrawrequest.js": "c257",
	"./yuki.js": "f51a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ced4";